'use client'

interface ConsultationCardProps {
  consultationId: string
  // consultationDate:string
  clinic: string
  service: string
  nhsNumber: string
  prescriber: string
  patient: string
  dob: string
  followUp: string
  consultationFee: string
  children: React.ReactNode
  isFollowup: boolean
}

const ConsultationLiveCard: React.FC<ConsultationCardProps> = ({
  consultationId,
  // consultationDate,
  clinic,
  service,
  nhsNumber,
  prescriber,
  patient,
  dob,
  followUp,
  consultationFee,
  children,
  isFollowup,
}) => {
  return (
    <div
      className={`
        mb- flex w-full flex-col rounded-md border-2 border-[#D4D8E3] bg-white
        
      `}
    >
      <div
        className={`
          grid grid-cols-1 md:gap-6 gap-2 md:px-9 px-5 md:pt-7 pt-4 md:pb-10 pb-4

          md:grid-cols-3
        `}
      >
        <div className='flex flex-col md:gap-5 gap-2'>
          <div className='flex'>
            <h1
              className={`
                min-w-36 shrink-0 text-[14px] font-semibold 
              `}
            >
              Consultation ID:
            </h1>
            <p className='break-all text-[14px] font-light'>{consultationId}</p>
          </div>
          {/* <div className='flex'>
            <h1 className={`
              min-w-36 shrink-0 text-[14px] font-[500] text-[#252234]
            `}>consultation Date:</h1>
            <p className='break-words text-[14px] font-[500] text-gray-500'>{consultationDate}</p>
          </div> */}
          <div className='flex'>
            <h1
              className={`
                min-w-36 shrink-0 text-[14px] font-semibold 
              `}
            >
              Clinic Name:
            </h1>
            <p className='break-words text-[14px] font-light'>{clinic}</p>
          </div>
          <div className='flex'>
            <h1 className='min-w-36 shrink-0 text-[14px] font-semibold'>
              {isFollowup ? 'Follow-up' : 'Consultation'} Fee:
            </h1>
            <h1 className='text-[14px] font-semibold '>{consultationFee}</h1>
          </div>

          
        </div>
        <div className='flex flex-col md:gap-5 gap-2'>
          <div className='flex'>
            <h1
              className={`
                min-w-36 shrink-0 text-[14px] font-semibold 
              `}
            >
              NHS Number:
            </h1>
            <p className='text-[14px] font-light'>{nhsNumber}</p>
          </div>
          <div className='flex'>
            <h1
              className={`
                min-w-36 shrink-0 text-[14px] font-semibold 
              `}
            >
              Prescriber Name:
            </h1>
            <p className='break-words text-[14px] font-light'>{prescriber}</p>
          </div>
          <div className='flex'>
            <h1
              className={`
                min-w-36 shrink-0 text-[14px] font-semibold 
              `}
            >
              Patient Name:
            </h1>
            <p className='break-words text-[14px] font-light'>{patient}</p>
          </div>
          
          <div className='invisible flex hidden '>
            <h1
              className={`
                min-w-36 shrink-0 text-[14px] font-semibold 
              `}
            >
              Follow up:
            </h1>
            <a href='#' className='text-[14px] text-primary-yellow'>
              {followUp}
            </a>
          </div>
        </div>
        <div className='flex flex-col md:gap-5 gap-2'>

          <div className='flex'>
            <h1
              className={`
                min-w-36 shrink-0 text-[14px] font-semibold
              `}
            >
              Service:
            </h1>
            <p className='break-words text-[14px] font-light'>{service}</p>
          </div>
          <div className='flex'>
            <h1
              className={`
                min-w-36 shrink-0 text-[14px] font-semibold 
              `}
            >
              DOB:
            </h1>
            <p className='text-[14px] font-light'>{dob}</p>
          </div>

        </div>
      </div>
      {children}
    </div>
  )
}

export default ConsultationLiveCard
